// Libs
import classNames from 'classnames/bind';
import { Outlet } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
// Components, Layouts, Pages
import { Header, Sidebar } from '~/layouts/main/components';
// Others
// Styles, images, icons
import styles from './Main.module.scss';
import { useAppDispatch, useAppSelector } from '~/utils/redux/hooks';
import { getProfile } from '~/thunks/user/userThunk';
import { RingCentralContext } from '~/context';
import { StorageEnum } from '~/utils/enum/base';

const cx = classNames.bind(styles);

const Main = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { setIsJoinPage } = useContext(RingCentralContext);
  const dispatch = useAppDispatch();
  //#endregion Declare Hook

  //#region Selector
  const { isRefreshProfile } = useAppSelector((state) => state.user);
  //#endregion Selector

  //#region Declare State
  const [isLoggedIn] = useState<string | null>(localStorage.getItem(StorageEnum.ACCESS_TOKEN)! || null);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (isLoggedIn) {
      setIsJoinPage && setIsJoinPage(true);
    }

    return () => {
      setIsJoinPage && setIsJoinPage(false);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getProfileUser();
  }, [isRefreshProfile]);
  //#endregion Implement Hook

  //#region Handle Function

  const getProfileUser = () => {
    dispatch(getProfile())
      .unwrap()
      .then((_resp) => {})
      .catch(() => {})
      .finally(() => {});
  };
  //#endregion Handle Function

  return (
    <div id='maidLayout' className={cx('mainContainer')}>
      <Sidebar />

      <section className={cx('contentGroupSection')}>
        <Header />

        <section id='mainContentSection' className={cx('contentSection')}>
          <Outlet />
        </section>
      </section>
    </div>
  );
};

export default Main;
